import { render, staticRenderFns } from "./ViewStatusOptionPage.vue?vue&type=template&id=189fb48d&"
import script from "./ViewStatusOptionPage.vue?vue&type=script&lang=js&"
export * from "./ViewStatusOptionPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports